import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { vestingCardStyles } from './vestingCardStyles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import { HelperText } from '../HelperText/HelperText';

export interface IVestingCardRowInfoProps {
  keyTitle: string;
  children: JSX.Element;
  subtitle?: JSX.Element;
  isLoading?: boolean;
  helperText?: string;
}
export const VestingCardRowInfo = ({
  keyTitle,
  children,
  isLoading,
  subtitle,
  helperText
}: IVestingCardRowInfoProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isDark = theme.palette.mode === 'dark';
  const isBuyerUser = false;
  const classes = vestingCardStyles(theme, isDark, isBuyerUser);
  const isDownLg = useMediaQuery(theme.breakpoints.down('lg'));
  const typographyVariantSubtitle = isDownLg ? 'body2' : 'body1';
  return (
    <Grid
      xs={6}
      sm={5}
      md={12}
      item
      container
      direction={{ xs: 'column', sm: 'row' }}
      justifyContent='space-between'
      sx={classes.cell}
      wrap='nowrap'
    >
      <Grid item container xs='auto' sx={classes.containerTitleAndHelper}>
        <Grid item>
          <Typography
            variant='body2'
            color={theme.palette.text.primary}
            sx={classes.dataTitle}
          >
            {t(keyTitle)}
          </Typography>
        </Grid>
        {helperText && (
          <Grid item>
            <HelperText text={helperText} />
          </Grid>
        )}
      </Grid>
      <Grid item>
        {isLoading ? (
          <Skeleton variant='text' width={100} height={20} />
        ) : (
          <>
            <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
              <Typography
                variant={typographyVariantSubtitle}
                sx={classes.dataNumber}
              >
                {children}
              </Typography>
              <Typography
                variant='subtitle2'
                color='secondary'
                sx={classes.dataSubtitle}
              >
                {subtitle}
              </Typography>
            </Box>
          </>
        )}
      </Grid>
    </Grid>
  );
};
